import oldStyled from "packages/styled-components";

export const styled = oldStyled;
